import { render, staticRenderFns } from "./AdvancedTxPlannedV2Drill.vue?vue&type=template&id=2b5f4d66&scoped=true"
import script from "./AdvancedTxPlannedV2Drill.vue?vue&type=script&lang=js"
export * from "./AdvancedTxPlannedV2Drill.vue?vue&type=script&lang=js"
import style0 from "./AdvancedTxPlannedV2Drill.vue?vue&type=style&index=0&id=2b5f4d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5f4d66",
  null
  
)

export default component.exports